import { useState, useEffect } from "react";
import { G, ADMIN_API, adminInput, IcoKB } from "../../design/tokens";

export default function KBModule({ authHeader, onStatus, canWrite }) {
  const [files, setFiles]           = useState([]);
  const [selected, setSelected]     = useState(null);
  const [editorContent, setEditorContent] = useState("");
  const [newFileName, setNewFileName] = useState("");
  const [loading, setLoading]       = useState(false);

  const loadFiles = async () => {
    setLoading(true);
    const res  = await fetch(`${ADMIN_API}/files`, { headers: authHeader });
    const data = await res.json();
    setFiles(data.files || []);
    setLoading(false);
  };

  const openFile = async (key) => {
    const res  = await fetch(`${ADMIN_API}/files/${encodeURIComponent(key)}`, { headers: authHeader });
    const data = await res.json();
    setSelected({ key });
    setEditorContent(data.content || "");
  };

  const saveFile = async () => {
    setLoading(true);
    const res  = await fetch(`${ADMIN_API}/files/${encodeURIComponent(selected.key)}`, { method: "PUT", headers: authHeader, body: JSON.stringify({ content: editorContent }) });
    const data = await res.json();
    onStatus(data.message || data.error);
    setLoading(false);
    setTimeout(() => onStatus(""), 3000);
  };

  const createFile = async () => {
    if (!newFileName) return;
    const key  = newFileName.endsWith(".md") ? newFileName : `${newFileName}.md`;
    const res  = await fetch(`${ADMIN_API}/files`, { method: "POST", headers: authHeader, body: JSON.stringify({ key, content: `# ${key}\n\nAdd content here.` }) });
    const data = await res.json();
    onStatus(data.message || data.error);
    setNewFileName("");
    loadFiles();
    setTimeout(() => onStatus(""), 3000);
  };

  const deleteFile = async (key) => {
    if (!window.confirm(`Delete ${key}?`)) return;
    await fetch(`${ADMIN_API}/files/${encodeURIComponent(key)}`, { method: "DELETE", headers: authHeader });
    if (selected?.key === key) setSelected(null);
    loadFiles();
  };

  useEffect(() => { loadFiles(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const mdFiles = files.filter(f => f.type !== "upload");
  const uploads = files.filter(f => f.type === "upload");

  return (
    <div style={{ display: "flex", height: "100%" }}>
      <div style={{ width: 256, borderRight: "1px solid rgba(255,255,255,0.05)", display: "flex", flexDirection: "column", padding: "20px 14px", overflowY: "auto", background: "rgba(4,10,24,0.5)", flexShrink: 0 }}>
        <div style={{ display: "flex", gap: 8, marginBottom: 18 }}>
          {[{ label: "DOCS", val: mdFiles.length, color: "#2563EB" }, { label: "FILES", val: uploads.length, color: "#7C3AED" }].map(s => (
            <div key={s.label} style={{ flex: 1, background: `${s.color}14`, border: `1px solid ${s.color}2A`, borderRadius: 10, padding: "10px 0", textAlign: "center" }}>
              <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 22, fontWeight: 700, color: "#fff" }}>{s.val}</div>
              <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 9, color: "rgba(255,255,255,0.3)", letterSpacing: 1.5 }}>{s.label}</div>
            </div>
          ))}
        </div>
        <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 9, color: "rgba(255,255,255,0.25)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 8 }}>Markdown</div>
        {canWrite && (
          <div style={{ display: "flex", gap: 6, marginBottom: 10 }}>
            <input value={newFileName} onChange={e => setNewFileName(e.target.value)} onKeyDown={e => e.key === "Enter" && createFile()} placeholder="new-file.md" style={adminInput({ fontSize: 12, padding: "7px 10px", marginBottom: 0 })} />
            <button onClick={createFile} style={{ padding: "7px 13px", borderRadius: 9, border: "none", background: G.btnGrad, color: "#fff", cursor: "pointer", fontSize: 15, flexShrink: 0, boxShadow: G.btnShadow }}>+</button>
          </div>
        )}
        {loading && <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.25)", padding: "8px 4px" }}>Loading…</div>}
        {mdFiles.map(f => (
          <div key={f.key} style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 2 }}>
            <button onClick={() => openFile(f.key)} style={{ flex: 1, textAlign: "left", padding: "8px 10px", borderRadius: 8, border: `1px solid ${selected?.key === f.key ? "rgba(37,99,235,0.45)" : "transparent"}`, background: selected?.key === f.key ? "rgba(37,99,235,0.13)" : "transparent", color: selected?.key === f.key ? "#fff" : "rgba(255,255,255,0.45)", fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, cursor: "pointer", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", transition: "all 0.15s" }}>
              <span style={{ marginRight: 6, opacity: 0.4, fontSize: 11 }}>MD</span>{f.key}
            </button>
            {canWrite && <button onClick={() => deleteFile(f.key)} style={{ width: 22, height: 22, borderRadius: 5, border: "none", background: "transparent", color: "rgba(248,113,113,0.5)", cursor: "pointer", fontSize: 16, lineHeight: 1, flexShrink: 0 }}>×</button>}
          </div>
        ))}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.05)", paddingTop: 14, marginTop: 14 }}>
          <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 9, color: "rgba(255,255,255,0.25)", letterSpacing: 2, textTransform: "uppercase", marginBottom: 10 }}>Uploads</div>
          {canWrite && (
            <label style={{ display: "block", padding: "9px 10px", borderRadius: 9, border: "1px dashed rgba(124,58,237,0.3)", cursor: "pointer", textAlign: "center", fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.35)", marginBottom: 10 }}>
              + Upload PDF / Image
              <input type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: "none" }} onChange={async (e) => {
                const file = e.target.files[0]; if (!file) return;
                onStatus("Uploading…");
                const reader = new FileReader();
                reader.onload = async (ev) => {
                  const base64 = ev.target.result.split(",")[1];
                  const res  = await fetch(`${ADMIN_API}/files`, { method: "POST", headers: authHeader, body: JSON.stringify({ key: file.name, fileData: base64, contentType: file.type }) });
                  const data = await res.json();
                  onStatus(data.message || data.error); loadFiles(); setTimeout(() => onStatus(""), 3000);
                };
                reader.readAsDataURL(file); e.target.value = "";
              }} />
            </label>
          )}
          {uploads.map(f => (
            <div key={f.key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "6px 8px", borderRadius: 8, marginBottom: 3, background: "rgba(124,58,237,0.07)", border: "1px solid rgba(124,58,237,0.12)" }}>
              <span style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.4)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 170 }}>📄 {f.key.replace("uploads/", "")}</span>
              {canWrite && <button onClick={() => deleteFile(f.key)} style={{ border: "none", background: "transparent", color: "rgba(248,113,113,0.5)", cursor: "pointer", fontSize: 16, lineHeight: 1 }}>×</button>}
            </div>
          ))}
        </div>
      </div>

      <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "28px 32px", gap: 16, overflowY: "auto" }}>
        {selected ? (
          <>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0 }}>
              <div>
                <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 15, color: "#fff", fontWeight: 600 }}>{selected.key}</div>
                <div style={{ fontFamily: "'Space Grotesk', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.3)", marginTop: 3 }}>Markdown Editor</div>
              </div>
              {canWrite && <button onClick={saveFile} disabled={loading} style={{ padding: "10px 28px", borderRadius: 10, border: "none", background: G.btnGrad, color: "#fff", fontFamily: "'Space Grotesk', sans-serif", fontSize: 13, fontWeight: 600, cursor: "pointer", boxShadow: G.btnShadow, opacity: loading ? 0.7 : 1 }}>{loading ? "Saving…" : "Save Changes"}</button>}
            </div>
            <textarea value={editorContent} onChange={e => canWrite && setEditorContent(e.target.value)} readOnly={!canWrite}
              style={{ flex: 1, resize: "none", padding: "22px 24px", borderRadius: 14, border: "1px solid rgba(255,255,255,0.06)", background: "rgba(4,10,24,0.7)", color: "#93C5FD", fontFamily: "'Fira Code', 'JetBrains Mono', monospace", fontSize: 13, lineHeight: 1.85, outline: "none", minHeight: 500 }}
            />
          </>
        ) : (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 14 }}>
            <div style={{ width: 60, height: 60, borderRadius: 16, background: "rgba(37,99,235,0.1)", border: "1px solid rgba(37,99,235,0.2)", display: "flex", alignItems: "center", justifyContent: "center" }}><IcoKB /></div>
            <div style={{ fontFamily: "'Space Grotesk', sans-serif", color: "rgba(255,255,255,0.25)", fontSize: 14, textAlign: "center" }}>
              Select a file to {canWrite ? "edit" : "view"}
              {canWrite && <div style={{ fontSize: 12, marginTop: 4 }}>or create a new one from the panel</div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
